import { render, staticRenderFns } from "./MobileCompanyProfile.vue?vue&type=template&id=50c3a326&scoped=true"
import script from "./MobileCompanyProfile.vue?vue&type=script&lang=js"
export * from "./MobileCompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./MobileCompanyProfile.vue?vue&type=style&index=0&id=50c3a326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c3a326",
  null
  
)

export default component.exports